import { jsxs as I, Fragment as fe, jsx as a } from "react/jsx-runtime";
import { Modal as pe, FieldErrorAndDescription as ue, PrimaryButton as j, toast as y } from "@systemeio/ui";
import { useState as u, useEffect as ge } from "react";
import { twMerge as me } from "tailwind-merge";
import { useTranslation as he } from "../../i18n.mjs";
import { useFileUploaderManager as _e } from "./hooks/use-file-uploader-manager.mjs";
import { useStateWatcher as B } from "../../utils/use-state-watcher.mjs";
import { FileDropZone as Fe } from "../../components/file-drop-zone/index.mjs";
import { FileItem as g } from "../../components/file-item/file-item.mjs";
import { isImageFile as L } from "../../utils/is-image.mjs";
import { ImageCropperModal as Ue } from "../image-cropper/image-cropper-modal.mjs";
import { getImageAspectRatio as Ce, areAspectRatiosEqual as we } from "../../utils/aspect-ratio.mjs";
import { getArrayDifferenceBy as S } from "../../utils/get-array-difference-by.mjs";
import { FileUploaderItemStateEnum as d } from "./types/file-uploader-item-type.mjs";
const Be = ({
  uploaderRef: E,
  opened: T,
  source: M,
  imageCropperModalProps: c,
  showCroppingNote: Z,
  acceptTypes: q,
  fileManagerApiType: G,
  actionLabel: z,
  singleFileMode: R,
  openCroppingModalOnAdding: H,
  requireCropping: J,
  onClose: x,
  onDone: W
}) => {
  const { t: l, tICU: b } = he(), [f, N] = u(!1), [m, h] = u(), {
    items: n,
    waitingUploadItems: K,
    waitingUploadFiles: _,
    uploadedFiles: p,
    replaceWaitingUploadFiles: Q,
    addFilesToWaitingUpload: O,
    replaceFileInWaitingUploadItem: V,
    deleteWaitingUploadItem: X,
    deleteUploadingItem: Y,
    startUploading: $,
    startUploadingAll: P,
    clearAll: ee
  } = _e({
    fileManagerApiType: G,
    source: M
  }), te = !!n.length, re = !!_.length, F = p.length, U = n.length, oe = F && U === F;
  ge(
    function() {
      n.some(
        (i) => i.state === d.Waiting && i.error
      ) || h(void 0);
    },
    [n]
  );
  const C = async (e) => {
    var w;
    const t = (w = c == null ? void 0 : c.imageCropperProps) == null ? void 0 : w.aspectRatio;
    if (!L(e) || !t || isNaN(t))
      return !0;
    const i = URL.createObjectURL(e), [o, r] = await Ce(i);
    return !!we(r, t);
  };
  B(K, async (e, t) => {
    if (!H) return;
    const { added: i } = e ? S(e, t, (o) => o.uid) : { added: t };
    for (const o of i)
      if (!await C(o.file)) {
        k(o);
        break;
      }
  }), B(_, async (e, t) => {
    if (!Z) return;
    const { added: i } = e ? S(e, t, (o) => o) : { added: t };
    for (const o of i)
      if (!await C(o)) {
        y(
          l("file_manager.image_cropper.aspect_ratio.need_to_crop_note", {
            name: o.name
          })
        );
        break;
      }
  });
  const ie = async (e) => {
    if (R)
      Q(e);
    else {
      const t = O(e);
      t > 0 && y(
        b("file_manager.file_upload.duplicates_skipped", {
          count: t
        })
      );
    }
  }, ae = () => {
    p.length && W(p), x();
  }, le = () => {
    W(p), x();
  }, ne = async () => {
    const e = _;
    if (e.length)
      try {
        if (h(void 0), N(!0), J) {
          for await (const r of e)
            if (!await C(r))
              throw new Error(
                l("file_manager.image_cropper.aspect_ratio.need_to_crop_note", {
                  name: r.name
                })
              );
        }
        const t = await P(), i = t.filter((r) => r.status === "fulfilled").map((r) => r.value).filter((r) => !!r), o = t.filter((r) => r.status === "rejected");
        if (o.length)
          throw new Error(
            b("file_manager.file_upload.upload_incomplete_error", {
              totalFailed: o.length,
              totalFiles: e.length
            })
          );
        i.length && y.success(l("file_manager.file_upload.uploaded_successfully"));
      } catch (t) {
        const i = t instanceof Error ? t : new Error(l("file_manager.error"));
        h(i);
      } finally {
        N(!1);
      }
  }, se = (e) => {
    $(e.uid).catch(() => {
    });
  }, [de, A] = u(!1), [s, D] = u(), k = (e) => {
    A(!0), D(e);
  }, v = () => {
    A(!1), D(void 0);
  }, ce = (e) => {
    s && (V(s.uid, e), v());
  };
  return E && (E.current = {
    addFilesToWaitingUpload: O
  }), /* @__PURE__ */ I(fe, { children: [
    /* @__PURE__ */ a(
      pe,
      {
        title: l("file_manager.file_upload.upload_files"),
        titleClassName: "text-2xl font-semibold",
        contentClassName: "pt-[14px]",
        isFetching: f,
        opened: T,
        onClose: ae,
        afterLeave: () => ee(),
        children: /* @__PURE__ */ I("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ a(
            Fe,
            {
              acceptTypes: q,
              onSelect: ie,
              dropZoneClassName: me("min-h-[400px]", !te && "items-center"),
              label: l("file_manager.file_upload.drop_files_here"),
              disabled: f,
              multiple: !R,
              displayItemsInGrid: !0,
              children: n.map((e) => e.state === d.Waiting ? /* @__PURE__ */ a(
                g,
                {
                  wide: !0,
                  file: e.file,
                  error: e.error,
                  showEditButton: L(e.file),
                  onEdit: () => k(e),
                  showDeleteButton: !0,
                  onDeleteFile: () => X(e.uid),
                  onRetryAfterError: () => se(e)
                },
                e.uid
              ) : e.state === d.Uploading ? /* @__PURE__ */ a(
                g,
                {
                  wide: !0,
                  file: e.file,
                  progress: typeof e.progress == "number" && e.progress < 5 ? 5 : e.progress,
                  isLoading: !0,
                  showDeleteButton: !0,
                  onDeleteFile: () => Y(e.uid)
                },
                e.uid
              ) : e.state === d.Uploaded ? /* @__PURE__ */ a(g, { wide: !0, file: e.file, isLoaded: !0 }, e.uid) : e.state === d.Deleting ? /* @__PURE__ */ a(g, { wide: !0, file: e.file, isDeleting: !0 }, e.uid) : null)
            }
          ),
          /* @__PURE__ */ a(ue, { error: m == null ? void 0 : m.message, className: "text-center" }),
          /* @__PURE__ */ I("div", { className: "flex items-center justify-between gap-3", children: [
            /* @__PURE__ */ a("div", { className: "text-text-tertiary text-sm", children: U > 0 && l("file_manager.file_upload.files_uploaded", {
              count: F,
              totalCount: U
            }) }),
            oe ? /* @__PURE__ */ a(j, { onClick: le, children: l("file_manager.done") }) : /* @__PURE__ */ a(
              j,
              {
                isFetching: f,
                onClick: ne,
                disabled: !re && !f,
                children: z ?? l("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ a(
      Ue,
      {
        imageFile: s == null ? void 0 : s.file,
        opened: de,
        onClose: v,
        onCrop: ce,
        ...c
      }
    )
  ] });
};
export {
  Be as FileUploaderModal
};
